export const GET_ALL_ROLE_DATA = 'GET_ALL_ROLE_DATA';